import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.contentmap.editAbilityConfirmation.title',
    defaultMessage: 'HABILITY SAVED!',
  },
  subtitle: {
    id: 'simulated.contentmap.editAbilityConfirmation.subtitle',
    defaultMessage: 'New ability successfully saved!',
  },
  continue: {
    id: 'simulated.contentmap.editAbilityConfirmation.continue',
    defaultMessage: 'Continue',
  },
});
